import iconCommentActive from '../img/icon-comment-active.svg';
import iconCommentActiveBlue from '../img/icon-comment-active-blue.svg';
import iconCommentActiveBlue_004986 from '../img/icon-comment-active-blue-004986.svg';
import iconCommentActiveBlue_015587 from '../img/icon-comment-active-blue-015587.svg';
import iconCommentActiveGreen from '../img/icon-comment-active-green.svg';
import iconCommentActiveTeal_007c8e from '../img/icon-comment-active-teal-007c8e.svg';
import iconCommentActiveTeal_009bb1 from '../img/icon-comment-active-teal-009bb1.svg';
import iconCommentActiveYellow from '../img/icon-comment-active-yellow.svg';
import iconCommentActiveYellow_fadfaa from '../img/icon-comment-active-yellow-fadfaa.svg';
import iconCommentInactive from '../img/icon-comment-none.svg';

export const getFeedbackIcon = (color = '') => {
  switch (color) {
    case 'none':
      return iconCommentInactive;
    case 'blue':
      return iconCommentActiveBlue;
    case 'green':
      return iconCommentActiveGreen;
    case 'yellow':
      return iconCommentActiveYellow;
    case '#004986':
      return iconCommentActiveBlue_004986;
    case '#015587':
      return iconCommentActiveBlue_015587;
    case '#007c8e':
      return iconCommentActiveTeal_007c8e;
    case '#009bb1':
      return iconCommentActiveTeal_009bb1;
    case '#fadfaa':
      return iconCommentActiveYellow_fadfaa;
    default:
      return iconCommentActive;
  }
};
